// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__2h-Ru","active":"styles_active__34_4r","btn":"styles_btn__1i81J"};